import { BLOCK_SIZES, DEFAULT_VALUES, MOTION_TYPES } from '../../constants';
import type {
  BlockSize,
  MotionType,
  TextAlignment,
  WatermarkBlockData,
} from '../../types';

// Interface for optional parameters when creating a watermark block
type WatermarkBlockDataParams = {
  id?: string;
  position?: { x: number; y: number };
  width?: number;
  displayName?: boolean;
  displayEmail?: boolean;
  displayIP?: boolean;
  displayDateTime?: boolean;
  displayShareCreator?: boolean;
  customText?: string;
  opacity?: number;
  rotation?: number;
  size?: BlockSize;
  color?: string;
  motion?: MotionType;
  section?: string;
  textAlignment?: TextAlignment;
  textShadow?: boolean;
};

/**
 * Creates a new watermark block with default values and optional overrides
 * @param params Optional parameters to override default values
 * @returns A new WatermarkBlockData object
 */
export const createWatermarkBlock = (
  params: WatermarkBlockDataParams = {}
): WatermarkBlockData => {
  return {
    id: params.id || `block-${Date.now()}`,
    position: params.position || { x: 0, y: 0 },
    width: params.width || DEFAULT_VALUES.WIDTH,
    displayName: params.displayName || false,
    displayEmail: params.displayEmail || false,
    displayIP: params.displayIP || false,
    displayDateTime: params.displayDateTime || false,
    displayShareCreator: params.displayShareCreator || false,
    customText: params.customText || DEFAULT_VALUES.CUSTOM_TEXT,
    opacity: params.opacity || DEFAULT_VALUES.OPACITY,
    rotation: params.rotation || DEFAULT_VALUES.ROTATION,
    size: params.size || BLOCK_SIZES.MEDIUM,
    color: params.color || DEFAULT_VALUES.COLOR,
    motion: params.motion || MOTION_TYPES.NONE,
    section: params.section || DEFAULT_VALUES.SECTION,
    textAlignment: params.textAlignment || DEFAULT_VALUES.TEXT_ALIGNMENT,
    textShadow: params.textShadow || false,
  };
};
